module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-view",
    class: {
      sentErp: _vm.value.sent_to_erp != 0
    }
  }, [_c('div', {
    staticClass: "customer-header",
    class: {
      active: _vm.expanded
    },
    on: {
      "click": function($event) {
        return _vm.display()
      }
    }
  }, [_c('span', {
    staticClass: "arrow_key",
    class: {
      expanded: _vm.expanded
    }
  }, [_c('i', {
    staticClass: "angle left icon"
  })]), _vm._v(" "), (_vm.home) ? _c('div', {
    staticClass: "float-right"
  }, [_c('button', {
    staticClass: "ui button small",
    on: {
      "click": function($event) {
        return _vm.openCustomer()
      }
    }
  }, [_vm._v("Client")])]) : _vm._e(), _vm._v(" "), _c('h4', [_vm._v("\n      " + _vm._s(_vm.$t('Order')) + "\n      " + _vm._s(_vm.value.reference) + "\n      "), _c('span', {
    staticClass: "id-order"
  }, [_vm._v("(" + _vm._s(_vm.value.id) + ") ")]), _vm._v(" "), _c('span', {
    staticClass: "order-price"
  }, [_vm._v(_vm._s(_vm._f("price")(_vm.value.total_paid)))]), _vm._v(" "), _c('span', [_c('a', {
    staticClass: "ui button small blue btn_customer",
    attrs: {
      "target": "_blank",
      "href": _vm.prestashop_order_link(_vm.value.id)
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('View on Prestashop')) + "\n      ")])])]), _vm._v(" "), _c('div', [_vm._v("\n      " + _vm._s(_vm.$t('Customer')) + "\n\n      "), _c('b', [_vm._v(_vm._s(_vm.value.customer.firstname) + " " + _vm._s(_vm.value.customer.lastname))])]), _vm._v(" "), _c('div', [_vm._v("\n      " + _vm._s(_vm.$t('Address')) + "\n\n      "), (_vm.value.delivery_address) ? _c('span', {
    staticClass: "bold"
  }, [_vm._v("\n        " + _vm._s(_vm.value.delivery_address.address1) + " " + _vm._s(_vm.value.delivery_address.address2) + " " + _vm._s(_vm.value.delivery_address.postcode) + " " + _vm._s(_vm.value.delivery_address.city) + "\n      ")]) : _vm._e()]), _vm._v(" "), _c('div', [_vm._v("\n      " + _vm._s(_vm.$t('Phone')) + "\n\n      "), (_vm.value.delivery_address) ? _c('span', {
    staticClass: "bold"
  }, [_vm._v("\n        " + _vm._s(_vm.value.delivery_address.phone_mobile) + "\n      ")]) : _vm._e()]), _vm._v(" "), _c('div', [_vm._v("\n      " + _vm._s(_vm.$t('Order made on')) + "\n      "), _c('b', [_vm._v(_vm._s(_vm.value.date_add))])])]), _vm._v(" "), (_vm.expanded) ? _c('div', {
    staticClass: "customer-details"
  }, [_c('div', {
    staticClass: "message"
  }, [(_vm.value.message != null) ? _c('div', {
    staticClass: "message-content"
  }, [_vm._v("\n        " + _vm._s(_vm.value.message) + "\n      ")]) : _vm._e()]), _vm._v(" "), _c('table', {
    staticClass: "ui celled small very compact table center aligned"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "three wide productName"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('Name')) + "\n          ")]), _vm._v(" "), (_vm.currentCustomer) ? _c('th', [_vm._v("\n            " + _vm._s(_vm.$t('Cart')) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "one wide"
  }, [_vm._v(_vm._s(_vm.$t('Reference')))]), _vm._v(" "), _c('th', {
    staticClass: "one wide"
  }, [_vm._v(_vm._s(_vm.$t('Qty')))]), _vm._v(" "), _c('th', {
    staticClass: "one wide"
  }, [_vm._v(_vm._s(_vm.$t('Price')))]), _vm._v(" "), _c('th', {
    staticClass: "one wide"
  }, [_vm._v(_vm._s(_vm.$t('Group Reduction')))]), _vm._v(" "), _c('th', {
    staticClass: "one wide"
  }, [_vm._v(_vm._s(_vm.$t('Total Price')))]), _vm._v(" "), _c('th', {
    staticClass: "one wide"
  }, [_vm._v(_vm._s(_vm.$t('ERP Status')))]), _vm._v(" "), _c('th', {
    staticClass: "one wide"
  }, [_vm._v(_vm._s(_vm.$t('ERP Ops')))]), _vm._v(" "), _c('th', {
    staticClass: "one wide"
  }, [_vm._v(_vm._s(_vm.$t('Product status')))])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.value.products), function(product, idx) {
    return _c('tr', {
      key: idx
    }, [_c('td', [_c('p', {
      staticClass: "text-left",
      domProps: {
        "innerHTML": _vm._f("formatProductName")(product.product_name)
      }
    })]), _vm._v(" "), (_vm.currentCustomer) ? _c('td', [(_vm.getQuantityInCart(product) > 0) ? _c('span', {
      staticStyle: {
        "color": "green"
      }
    }, [_vm._v("\n              " + _vm._s(_vm.getQuantityInCart(product)) + "\n            ")]) : _c('div', [(
      product.product_reference ||
      product.product_name != 'Transport'
    ) ? _c('button', {
      staticClass: "ui mini button blue add-button",
      attrs: {
        "title": "Add to cart"
      },
      on: {
        "click": function($event) {
          return _vm.addToCart(product)
        }
      }
    }, [_c('i', {
      staticClass: "add icon"
    })]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('td', [(product.customizable != 0) ? _c('div', [_c('table', {
      staticClass: "ui celled small very compact table center aligned reference-table"
    }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("reference")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(product.product_reference))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("tissue")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getTissu(product)))])])])])]) : _c('div', [(product.fms_id_formens_order) ? _c('table', {
      staticClass: "ui celled small very compact table center aligned reference-table"
    }, [_c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Factory reference')))]), _vm._v(" "), _c('td', {
      staticClass: "formens"
    }, [_vm._v("\n                      " + _vm._s(product.fms_factory_reference) + "\n                    ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Product type')))]), _vm._v(" "), _c('td', {
      staticClass: "formens"
    }, [_vm._v(_vm._s(product.fms_product_type))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Pattern base')))]), _vm._v(" "), _c('td', {
      staticClass: "formens"
    }, [_vm._v(_vm._s(product.fms_pattern_base))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Base size')))]), _vm._v(" "), _c('td', {
      staticClass: "formens"
    }, [_vm._v(_vm._s(product.fms_base_size))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Product')))]), _vm._v(" "), _c('td', [_vm._v("\n                      " + _vm._s(product.id_product) + "\n                    ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Combination')))]), _vm._v(" "), _c('td', [_vm._v("\n                      " + _vm._s(product.product_attribute_id) + "\n                    ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Original price')))]), _vm._v(" "), _c('td', {
      staticClass: "original-price"
    }, [_vm._v("\n                      " + _vm._s(_vm._f("price")(product.original_product_price)) + "\n                    ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Suggested price')))]), _vm._v(" "), _c('td', {
      staticClass: "formens"
    }, [_vm._v("\n                      " + _vm._s(_vm._f("price")(product.fms_suggested_price)) + "\n                    ")])])])]) : _c('table', {
      staticClass: "ui celled small very compact table left aligned attributes-table"
    }, [_c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Reference')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(product.reference || 'N/A'))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Product')))]), _vm._v(" "), _c('td', {
      class: product.source
    }, [_vm._v("\n                      " + _vm._s(product.id_product) + "\n                    ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Combination')))]), _vm._v(" "), _c('td', {
      class: product.source
    }, [_vm._v("\n                      " + _vm._s(product.id_combination ||
      product.id_product_attribute ||
      product.product_attribute_id) + "\n                    ")])]), _vm._v(" "), _vm._l((Object.keys(
      _vm.getOrderProductAttributeList(product)
    )), function(attribute_name, idx) {
      return _c('tr', {
        key: idx
      }, [_c('td', [_vm._v(_vm._s(attribute_name))]), _vm._v(" "), _c('td', {
        class: product.source
      }, [_vm._v("\n                      " + _vm._s(_vm.getOrderProductAttributeList(product)[attribute_name]) + "\n                    ")])])
    })], 2)])])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(product.product_quantity))]), _vm._v(" "), _c('td', {
      staticClass: "price"
    }, [_vm._v("\n            " + _vm._s(_vm._f("price")((product.fms_suggested_price ?
      product.fms_suggested_price :
      product.product_price))) + "\n          ")]), _vm._v(" "), _c('td', {
      staticClass: "group-reduction"
    }, [_vm._v("\n            " + _vm._s(parseFloat(product.group_reduction) > 0 &&
      product.id_product != 62988 ?
      ("-" + (Math.round(product.group_reduction)) + "%") :
      '') + "\n          ")]), _vm._v(" "), _c('td', {
      staticClass: "total-price"
    }, [_vm._v("\n            " + _vm._s(_vm._f("price")(product.total_price)) + "\n          ")]), _vm._v(" "), _c('td', {
      staticClass: "erp_status"
    }, [(product.erp_status) ? _c('span', {
      staticClass: "status",
      class: product.erp_status.toLowerCase()
    }, [_vm._v(_vm._s(product.erp_status))]) : _vm._e(), _vm._v(" "), (product.fms_id_formens_order) ? _c('a', {
      attrs: {
        "href": _vm.erp_link(product.fms_factory_reference),
        "target": "_blank"
      }
    }, [_vm._v("\n              " + _vm._s(product.fms_factory_reference) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "erp_ops"
    }, [(!product.fms_id_formens_order) ? _c('erp-modal', {
      ref: "erpModal",
      refInFor: true,
      attrs: {
        "order": _vm.value
      },
      model: {
        value: (_vm.value.products[idx]),
        callback: function($$v) {
          _vm.$set(_vm.value.products, idx, $$v)
        },
        expression: "value.products[idx]"
      }
    }, [(product.sent_to_erp == 0) ? _c('button', {
      staticClass: "ui mini compact button green",
      attrs: {
        "slot": "activator"
      },
      slot: "activator"
    }, [_vm._v("\n                " + _vm._s(_vm.$t('Send to ERP')) + "\n              ")]) : _vm._e(), _vm._v(" "), (product.sent_to_erp == 1) ? _c('button', {
      staticClass: "ui mini compact button yellow",
      attrs: {
        "slot": "activator"
      },
      slot: "activator"
    }, [_vm._v("\n                " + _vm._s(_vm.$t('Resend to ERP')) + "\n              ")]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('td', [(product.status !== 'Delivered') ? _c('product-status-modal', {
      ref: "productStatusModal",
      refInFor: true,
      attrs: {
        "order": _vm.value
      },
      model: {
        value: (_vm.value.products[idx]),
        callback: function($$v) {
          _vm.$set(_vm.value.products, idx, $$v)
        },
        expression: "value.products[idx]"
      }
    }, [_c('button', {
      staticClass: "ui button yellow",
      attrs: {
        "slot": "activator"
      },
      slot: "activator"
    }, [_vm._v("\n                " + _vm._s(_vm.$t('Mark as delivered')) + "\n              ")])]) : _c('button', {
      staticClass: "ui button green",
      attrs: {
        "slot": "activator",
        "disabled": ""
      },
      slot: "activator"
    }, [_vm._v("\n              " + _vm._s(_vm.$t('Delivered')) + "\n            ")])], 1)])
  }), _vm._v(" "), (_vm.value.total_discounts > 0) ? _c('tr', {
    staticClass: "total-discounts"
  }, [_c('td', [_vm._v("\n            " + _vm._s(_vm.$t('Total Discounts')) + "\n          ")]), _vm._v(" "), (_vm.currentCustomer) ? _c('td') : _vm._e(), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("-" + _vm._s(_vm._f("price")(_vm.value.total_discounts)))]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')]) : _vm._e(), _vm._v(" "), (_vm.value.total_paid >= 0) ? _c('tr', {
    staticClass: "total-paid"
  }, [_c('td', [_vm._v(_vm._s(_vm.$t('Total Paid')))]), _vm._v(" "), (_vm.currentCustomer) ? _c('td') : _vm._e(), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("price")(_vm.value.total_paid)))]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')]) : _vm._e()], 2)]), _vm._v(" "), (!_vm.hasFormensProductInCurrentOrder) ? _c('div', {
    staticClass: "sendBulk"
  }, [_c('button', {
    staticClass: "ui button green",
    attrs: {
      "disabled": _vm.loading == true
    },
    on: {
      "click": function($event) {
        _vm.showModal = true
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('Send all products to ERP')) + "\n        ")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('popup-modal', {
    attrs: {
      "index": _vm.showModal,
      "icon": "checkmark",
      "cancel_class": "ui red basic cancel inverted button",
      "confirm_class": "ui green ok inverted button",
      "text": "Are you sure you want to send all products to the ERP ?"
    },
    on: {
      "delete": function($event) {
        return _vm.sendOrderToERP()
      },
      "cancel": function($event) {
        _vm.showModal = null
      }
    }
  }), _vm._v(" "), _c('popup-modal', {
    attrs: {
      "index": _vm.order_again,
      "icon": "checkmark",
      "cancel_class": "ui red basic cancel inverted button",
      "confirm_class": "ui green ok inverted button",
      "text": "Are you sure you want to order this shirt again ?"
    },
    on: {
      "cancel": function($event) {
        _vm.order_again = null
      },
      "delete": function($event) {
        return _vm.orderSameShirt()
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62f283c1","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OrderView.vue
// module id = 502
// module chunks = 1